<template>
  <div v-if="['desktop'].includes($mq)"></div>
  <div v-else-if="displayBar()" class="SideNav-Mobile">
    <div :class="ActiveClass('themeList')" @click="startVisit">
      <img :src="getImgUrl(selectIcon('themeList', 'visite'))" class="imgMobile" />
      <div class="tipo">{{ $t('navBar.visit') }}</div>
    </div>
    <div :class="ActiveClass('listTasting')" @click="goto('listTasting')">
      <img :src="getImgUrl(selectIcon('listTasting', 'degustation'))" class="imgMobile" />
      <div class="tipo">{{ $t('navBar.taste') }}</div>
    </div>
    <div :class="ActiveClass('home')" v-on:click="$router.push('/')">
      <img :src="getImgUrl(selectIcon('home', 'Home'))" class="imgMobile" />
      <div class="tipo">{{ $t('navBar.home') }}</div>
    </div>
    <div :class="ActiveClass('quizList')" @click="goto('quizList')">
      <img :src="getImgUrl(selectIcon('quizList', 'quiz'))" class="imgMobile" />
      <div class="tipo">{{ $t('navBar.games') }}</div>
    </div>
    <div class="boxItems" @click="redirectToShop">
      <img :src="getImgUrl('boutique')" class="imgMobile" />
      <div class="tipo">{{ $t('navBar.shop') }}</div>
    </div>
  </div>
</template>

<script>
import { OPEN_NAVIGATION_DRAWER, CLOSE_NAVIGATION_DRAWER } from '@/helpers/eventBus'
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import remoteConfig from '@/lib/remote-config'
import { mapGetters } from 'vuex'

export default {
  name: 'Sidenav',
  mixins: [userMixin, remoteConfigMixin],
  data: () => ({
    isOpen: false
  }),
  computed: {
    ...mapGetters({
      themes: 'getThemes'
    }),
    socialMedia() {
      if (remoteConfig.getValue('social_media')) {
        return JSON.parse(JSON.parse(JSON.stringify(remoteConfig.getValue('social_media'))))
      }
      return []
    },
    isMobile() {
      return document.body.clientWidth < 767
    },
    welcomeMessage() {
      if (this.user && this.user.firstname) {
        return this.$t('userAccount.welcomeMessage', { firstname: this.user.firstname })
      } else {
        return this.$t('userAccount.anonymousWelcomeMessage')
      }
    },
    availableLocales() {
      const languages = this.remoteConfig.getString('languages')

      if (languages) {
        return languages.split('|')
      }

      return []
    },
    actualRoute() {
      return this.$route.name
    }
  },
  methods: {
    displayBar() {
      return this.$route.name == 'splashScreen' ? false : true
    },
    selectIcon(routeName, name) {
      return this.actualRoute == routeName ? `${name}Active` : name
    },
    selectActive(routeName) {
      return this.actualRoute == routeName ? 'pageActive' : 'page'
    },
    ActiveClass(routeName) {
      return this.actualRoute == routeName ? 'boxItemsActive' : 'boxItems'
    },
    getImgUrl(icon) {
      if (!icon) return null

      const images = require.context('@/assets', false, /\.png$/)
      return images('./' + icon + '.png')
    },
    closeDrawer() {
      this.$eventBus.$emit(CLOSE_NAVIGATION_DRAWER)
    },
    goto(routeName) {
      this.$router.push({ name: routeName })
      this.closeDrawer()
    },
    logoutDrawer() {
      this.logout(() => {
        this.$router.push({ name: 'login' })
      })
      this.closeDrawer()
    },
    startVisit() {
      if (this.themes.length < 0) {
        this.$router.push({ name: 'home' })
        this.closeDrawer()
      } else {
        this.$router.push({ name: 'themeList' })
      }
    },
    redirectToShop() {
      window.open(this.remoteConfig.getString('shop_url'), '_blank')
    }
  },
  mounted() {
    this.$eventBus.$on(OPEN_NAVIGATION_DRAWER, () => {
      this.isOpen = true
    })

    this.$eventBus.$on(CLOSE_NAVIGATION_DRAWER, () => {
      this.isOpen = false
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.tipo {
  font-size: 13px;
}
.boxItemsActive {
  display: flex;
  background-color: #fff;
  box-shadow: 5px 5px 7px 5px rgba(0, 0, 0, 0.14);
  border: solid 2px $primary;
  color: #404040;
  flex-direction: column;
  align-items: center;
  width: 45px;
  padding: 20px 10px 8px 10px;
  border-radius: 23px 23px 0px 0px;
}
.boxItems {
  display: flex;
  color: #fff;
  margin-bottom: 8px;
  width: 55px;
  flex-direction: column;
  align-items: center;
}
.imgMobile {
  height: 25px;
  background-color: $primary;
  margin-bottom: 5px;
}
.SideNav-Mobile {
  position: fixed;
  top: calc(100% - 62px);
  background-color: $primary;
  width: 100%;
  height: 62px;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-around;
  text-align: center;
  // justify-content: center;
}
.page {
  color: #fff;
}
.pageActive {
  color: $primary;
  background-color: #fff;
}
.detailsSideNav {
  display: flex;
  flex-direction: column;
}
.Sidenav-Logo-Container {
  margin: 120px 70px;
  transform: scale(1.4);
  height: auto;
  width: auto;
  cursor: pointer;
}
.SideNav-Desktop {
  position: fixed;
  display: flex;
  width: 300px;
  height: 100%;
  flex-direction: column;
  background: #767676;
  justify-content: space-between;
  align-content: center;
  margin-right: 360px;
}
.list-social-media {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;

  .item-social-media {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
    @media screen and (max-width: 450px) {
      margin-left: 5px;
      margin-right: 5px;
    }
    .asset-rrecommendations {
      flex-direction: row;
    }
    img {
      width: 25px;
      height: 25px;
      @media screen and (max-width: 450px) {
        width: 15px;
        height: 15px;
      }
    }
  }
}
</style>
